import { useState } from 'react';
import { Intervention } from 'graphql-common';
import { UseBulkSelectResult } from '@lib/hooks/useTableItemsBulkSelect';

interface UseModalManagementProps {
  useBulkSelectResult: UseBulkSelectResult<Intervention>;
}

export interface UseModalManagementResult {
  closeAllModals: () => void;
  isInterventionDestroyModalOpened: boolean;
  isCategoryFormModalOpened: boolean;
  closeCategoryFormModal: () => void;
  openCategoryFormModal: () => void;
  openInterventionDestroyModal: () => void;
  closeInterventionDestroyModal: () => void;
  isInterventionCloseModalOpened: boolean;
  openInterventionCloseModal: () => void;
  closeInterventionCloseModal: () => void;
}

export default function useModalManagement(
  props: UseModalManagementProps,
): UseModalManagementResult {
  const { useBulkSelectResult } = props;
  const { handleSelectSingleTableItem } = useBulkSelectResult;
  const [isCategoryFormModalOpened, setCategoryFormModalOpened] =
    useState(false);
  const openCategoryFormModal = () => setCategoryFormModalOpened(true);
  const closeCategoryFormModal = () => setCategoryFormModalOpened(false);

  const [isInterventionDestroyModalOpened, setInterventionDestroyModalOpened] =
    useState(false);
  const openInterventionDestroyModal = () =>
    setInterventionDestroyModalOpened(true);
  const closeInterventionDestroyModal = () => {
    handleSelectSingleTableItem(null);
    setInterventionDestroyModalOpened(false);
  };

  const [isInterventionCloseModalOpened, setInterventionCloseModalOpened] =
    useState(false);
  const openInterventionCloseModal = () =>
    setInterventionCloseModalOpened(true);
  const closeInterventionCloseModal = () => {
    handleSelectSingleTableItem(null);
    setInterventionCloseModalOpened(false);
  };

  const closeAllModals = () => {
    handleSelectSingleTableItem(null);
    closeCategoryFormModal();
    closeInterventionDestroyModal();
    closeInterventionCloseModal();
  };

  return {
    closeAllModals,
    closeCategoryFormModal,
    openCategoryFormModal,
    openInterventionDestroyModal,
    closeInterventionDestroyModal,
    isInterventionDestroyModalOpened,
    isCategoryFormModalOpened,
    isInterventionCloseModalOpened,
    openInterventionCloseModal,
    closeInterventionCloseModal,
  };
}
